export default __webpack_public_path__ + "static/modal-error-6767b2760d27d138f1d0dea699fff592.svg";